export default {
  // Faculty specific texts
  color: 'Color',
  generalEducationFaculty: 'General Education',
  generalEducationTooltip: 'Allows the {subjects} of the {faculty} to be General Education.',
  yes: 'Yes',
  no: 'No',
  isGeneralEducation: 'This {faculty} is General Education',
  selectImagePlaceholder: 'Select or drag the image here...',
  dropImagePlaceholder: 'Drop the image here...',
  cannotDelete: 'Cannot delete the {faculty} if it has assigned {programs}',
}
